module.exports = __webpack_public_path__ + "img/coupon_detail_4@2x.cd6ce6e3.svg";